// extracted by mini-css-extract-plugin
module.exports = {"tooltipAnchor":"sK","tooltipContainer":"sL","showTooltip":"sM","customTooltip":"sN","srp_grid_price":"sO","srp_grid_property":"sP","vdp_price_details":"sQ","srp_row_property":"sR"};